export default function formatAmount(
    unformattedAmount: number,
    locale: 'fr' | 'en' = 'fr',
) {
    const dividedAmount = unformattedAmount / 100

    if (locale === 'en') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(dividedAmount)
    }

    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    }).format(dividedAmount)
}
